import { ProductInput } from "__graphql__/types";

import { GENERATED_SKU_PREFIX, ProductsMap } from "../stores/useTGTGBagStore";

export const isProductEligibleForBag = (
  productClassification: string[] | null,
  allowedCategories: string[],
  excludedCategories: string[],
): boolean => {
  if (allowedCategories.length === 0 && excludedCategories.length === 0) return true;
  if (!productClassification || productClassification.length === 0) return true;

  const isInAllowed =
    allowedCategories.length === 0 ||
    productClassification.some((c) => allowedCategories.includes(c));

  const isInExcluded = productClassification.some((c) => excludedCategories.includes(c));

  return isInAllowed && !isInExcluded;
};

export const isOverPriceLimit = (
  price: number | null,
  newTotalPrice: number,
  upperThreshold: number,
): boolean => {
  return price !== null && newTotalPrice >= price + upperThreshold;
};

export const calculatePriceExceedance = (
  overMaximum: boolean,
  bagPrice: number | null | undefined,
  totalPrice: number,
  maximumThreshold: number,
) => {
  const basePrice = bagPrice ?? 0;
  const maxAllowedTotal = basePrice + maximumThreshold;
  const exceedAmount = overMaximum
    ? Math.max(0, Math.round((totalPrice - maxAllowedTotal) * 100) / 100)
    : 0;

  return { maxAllowedTotal, exceedAmount };
};

export const transformToProductInput = (data: ProductsMap): ProductInput[] => {
  return Object.values(data)
    .filter((product) => !product.productSku.startsWith(GENERATED_SKU_PREFIX))
    .map((product) => ({
      quantity: product.quantity,
      sku: product.productSku,
    }));
};
